import { lazy, type ComponentType } from 'react';

type ComponentExport<TModule, TKey extends keyof TModule> =
  TModule[TKey] extends ComponentType<infer TProps> ? ComponentType<TProps> : never;

export function lazyNamed<TModule, TKey extends keyof TModule>(
  loader: () => Promise<TModule>,
  exportName: TKey,
) {
  return lazy(async () => {
    const module = await loader();
    return {
      default: module[exportName] as ComponentExport<TModule, TKey>,
    };
  });
}
